import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container } from 'reactstrap';
import RejseForm from '@/components/RejseForm';
import Booking from '@/components/Booking';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const CoronaTravelTest = ({ t }) => {
	return (
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={`COVID-19${t('navbar.covid')}`}
				description={`${t('coronatest.text4')} ${t('coronatest.text5')}`}
				keywords={`COVID-19 ${t('SEO.keywords_common')} ${t('SEO.keywords_coronatest')}`}
				canonical="/travel-test"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="coronatest-page" className="coronatest-page">
					<Container>
						<article>
							<h1 className="page_text font-weight-bold">{`COVID-19${t('navbar.covid')}`}</h1>
							<h3 className="page_subtext text-uppercase">{t('travel_certificate.title')}</h3>
							<hr className="vaccination-page_hr" />
							<p>{t('travel_certificate.text1')}</p>
							<p>{t('travel_certificate.text2')}</p>
							<h2 className="font-weight-bold">{t('travel_certificate.form_title')}</h2>
							<RejseForm />
							<h3 className="page_subtext text-uppercase">{t('coronatest.title')}</h3>
							<ol>
								<li>
									<strong>PCR COVID-19 test: </strong>
									{t('coronatest.text')}
								</li>
								<li>
									<strong>{t('coronatest.text1')}</strong>
									{t('coronatest.text2')}
								</li>
								<li>
									<strong>{t('coronatest.title5')}</strong>
									&nbsp; {t('coronatest.text19')}
								</li>
							</ol>
							{/* <p>
								<span className="font-weight-bold">{t('coronatest.title1')}</span>
								{t('coronatest.text3')}
							</p> */}
							<h3 className="font-weight-bold pb-4">{t('coronatest.title7')}</h3>
							<h3 className="page_subtext text-uppercase">{t('coronatest.answer')}</h3>
							<p>{t('coronatest.text24')}</p>
							<h3 className="page_subtext text-uppercase">{t('coronatest.price')}</h3>
							<p>1190 DKK {t('coronatest.text20')}</p>
							<hr className="vaccination-page_hr" />
							<h2 className="font-weight-bold">{t('coronatest.title4')}</h2>
							<p>{t('coronatest.text13')}</p>
							<p>{t('coronatest.text14')}</p>
							<h3 className="page_subtext text-uppercase">{t('coronatest.answer')}</h3>
							<p>{t('coronatest.text15')}</p>
							<h3 className="page_subtext text-uppercase">{t('coronatest.price')}</h3>
							<p>449 DKK {t('coronatest.text20')}</p>
							<hr className="vaccination-page_hr" />
							<h2 className="font-weight-bold">{t('coronatest.title5')}</h2>
							<p>{t('coronatest.text17')}</p>
							<p>{t('coronatest.text18')}</p>
							<h3 className="page_subtext text-uppercase">{t('coronatest.answer')}</h3>
							<p>{t('coronatest.text19')}</p>
							<h3 className="page_subtext text-uppercase">{t('coronatest.price')}</h3>
							<p>995 DKK {t('coronatest.text20')}</p>
							{/* <hr className="vaccination-page_hr" />
							<h2 className="font-weight-bold">{t('coronatest.title6')}</h2>
							<p>{t('coronatest.text21')}</p>
							<p>{t('coronatest.text22')}</p>
							<p>{t('coronatest.text23')}</p> */}
							<Booking />
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};

export default translate(CoronaTravelTest);
